import React from 'react';
import PropTypes from 'prop-types';
import Message from '../message/Message';


const PlayerLevel = ({startLevelBar, percentageLevelBar, endLevelBar}) => {
    return (
        <div className="rankRow">
            <div className="statColumn"><Message code="epic.ut.stats.progress_level" /></div>
            <div className="xpDataLabel">{startLevelBar}</div>
            <div className="progressDiv"><progress max="100" value={percentageLevelBar}></progress></div>
            <div className="xpDataLabel">{endLevelBar}</div>
        </div>
    )
}

PlayerLevel.propTypes = {
    startLevelBar: PropTypes.number,
    percentageLevelBar: PropTypes.number,
    endLevelBar: PropTypes.number
}

export default PlayerLevel
